import { render, staticRenderFns } from "./UpdateKeywordsPage.vue?vue&type=template&id=6ee80efc&scoped=true"
import script from "./UpdateKeywordsPage.vue?vue&type=script&lang=js"
export * from "./UpdateKeywordsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee80efc",
  null
  
)

export default component.exports